import { useIsLeoPermitted } from '@vision/ui/hooks';
import { lazy, Suspense } from 'react';

const LeoLazy = lazy(() => import('./Leo').then((m) => ({ default: m.Leo })));

export function LeoLoader() {
  const isLeoPermitted = useIsLeoPermitted();

  if (!isLeoPermitted) return null;

  return (
    <Suspense fallback={null}>
      <LeoLazy />
    </Suspense>
  );
}
